import { BASE_PATH, API_VERSION } from './apiconfig';

class RouteApi {
  static async createRoute(routeMetadata) {
    const url = `${BASE_PATH}/${API_VERSION}/route/`;
    const headers = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ routeMetadata }), // Shorthand for { routeMetadata: routeMetadata }
    };

    try {
      const response = await fetch(url, headers);

      if (!response.ok) {
        throw new Error(`Failed to create route: ${response.statusText}`);
      }

      // You can return or handle the response as needed
      return response.json();
    } catch (error) {
      console.error('Error creating route:', error);
      // Handle the error appropriately, e.g., throw it again or log it
      throw error;
    }
  }
  static async getRoute(polyline, travelMode) {
    const url = `${BASE_PATH}/${API_VERSION}/get-route`;
    const headers = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ polyline, travelMode }),
    };

    try {
      const response = await fetch(url, headers);

      if (!response.ok) {
        throw new Error();
      }

      // Parse and return the JSON response
      return response.json();
    } catch (error) {
      // Handle the error appropriately, e.g., throw it again or log it
      throw new Error();
    }
  }
  static async getRouteById(routeId) {
    const url = `${BASE_PATH}/${API_VERSION}/get-route`;
    const headers = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ routeId }),
    };

    try {
      const response = await fetch(url, headers);

      if (!response.ok) {
        throw new Error();
      }

      // Parse and return the JSON response
      return response.json();
    } catch (error) {
      // Handle the error appropriately, e.g., throw it again or log it
      throw new Error();
    }
  }
  static async getRouteWeather(localities) {
    const url = `${BASE_PATH}/${API_VERSION}/get-route-weather-AEMET`;
    const headers = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ localities }),
    };

    try {
      const response = await fetch(url, headers);

      if (!response.ok) {
        throw new Error();
      }

      // Parse and return the JSON response
      return response.json();
    } catch (error) {
      // Handle the error appropriately, e.g., throw it again or log it
      throw new Error();
    }
  }

  // Absolute URL of the dynamically-generated Open Graph image for a route,
  // used as og:image so shared links unfurl with a rich preview.
  static getRouteOgImageUrl(routeId) {
    return `${BASE_PATH}/${API_VERSION}/route/${routeId}/og-image.png`;
  }

  static async getRouteProfile(routeId) {
    const url = `${BASE_PATH}/${API_VERSION}/route/${routeId}/profile`;

    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error();
      }

      return response.json();
    } catch (error) {
      throw new Error();
    }
  }

  static async getRouteWeatherGoogle(localities) {
    const url = `${BASE_PATH}/${API_VERSION}/get-route-weather-google`;
    const headers = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ localities }),
    };

    try {
      const response = await fetch(url, headers);

      if (!response.ok) {
        throw new Error();
      }

      return response.json();
    } catch (error) {
      throw new Error();
    }
  }
}

export default RouteApi;
